import { inject, Injectable } from "@angular/core";
import { ApiHttpService } from "@itm/services";

@Injectable({ providedIn: 'root' })
export class CacActionService {
    private readonly http = inject(ApiHttpService);

    constructor() { }
    
    getActionById<T>(id: string){
        const url = `cac/action/${id}`;
        return this.http.GETT<T>(url);
    }
    
    doNotEscalate<T>(data: any){
        const url = `cac/action/donotescalate`;
        return this.http.POST<T>(url, data);
    }
    
    doResolve<T>(data: any){
        const url = `cac/action/resolve`;
        return this.http.POST<T>(url, data);
    }
    
    remind<T>(data: any){
        const url = `cac/action/remind`;
        return this.http.POST<T>(url, data);
    }
    
    archive<T>(data: any){
        const url = `cac/action/archive`;
        return this.http.POST<T>(url, data);
    }
    
    rejectPR<T>(url: any, data: any){
        // const url = `cac/action/${id}/${actionType}`;
        return this.http.POST<T>(url, data);
    }
    
    approvePR<T>(url: any, data: any){
        return this.http.POST<T>(url, data);
    }
    
    sendMessage<T>(id: any, data: any){
        const url = `cac/action/comment/${id}`;
        return this.http.POST<T>(url, data);
    }

    sendRejctMessage<T>(id: any, data: any){
        const url = `cac/action/reject-comment/${id}`;
        return this.http.POST<T>(url, data);
    }

    applyEasyResolve<T>(actionId: string, customerId: number){
        const url = `cac/action/${actionId}/applyeasy-resolve`;
        return this.http.POST<T>(url, { customerId });
    }
}